
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Database, RefreshCcw, Upload } from 'lucide-react';

interface AdminHeaderProps {
  onImportData?: () => Promise<void>;
  onSyncAccounts?: () => Promise<void>;
  isImporting?: boolean;
  isSynchronizing?: boolean;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ 
  onImportData, 
  onSyncAccounts,
  isImporting = false,
  isSynchronizing = false
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight mb-1">Administration</h1>
        <p className="text-muted-foreground">Gérez les utilisateurs, les escortes et les signalements.</p>
      </div>
      
      <div className="flex items-center gap-4 mt-4 md:mt-0">
        <Button 
          onClick={onImportData} 
          variant="outline"
          disabled={isImporting}
          className="flex items-center"
        >
          {isImporting ? (
            <>
              <RefreshCcw className="mr-2 h-4 w-4 animate-spin" />
              Importation...
            </>
          ) : (
            <>
              <Upload className="mr-2 h-4 w-4" />
              Importer des données
            </>
          )}
        </Button>
        
        <Button 
          onClick={onSyncAccounts} 
          variant="outline"
          disabled={isSynchronizing}
          className="flex items-center"
        >
          {isSynchronizing ? (
            <>
              <RefreshCcw className="mr-2 h-4 w-4 animate-spin" />
              Synchronisation...
            </>
          ) : (
            <>
              <Database className="mr-2 h-4 w-4" />
              Synchroniser les comptes
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default AdminHeader;
